import {PipeTransform, Pipe} from '@angular/core';
import {Utilities} from '../utilities/utilities.model';
import {DateUtilities} from '../utilities/date-utilities.model';

@Pipe({
	name: 'dateUTC'
})
export class DateUtcPipe implements PipeTransform {
	transform(date: any, formats: string | string[]): string {
		if (Utilities.isVoid(formats)) {
			return DateUtilities.convertDate(date);
		}

		if (typeof formats === 'string') {
			return DateUtilities.convertDate(date, formats);
		}

		let result = '';
		for (let i = 0; i < formats.length; i++) {
			result += DateUtilities.convertDate(date, formats[i]);
			if (i !== formats.length - 1) {
				result += ' ';
			}
		}

		return result;
	}
}

@Pipe({
	name: 'dateCustomFormat'
})
export class DateCustomFormatPipe implements PipeTransform {
	transform(date: any, customFormat: string, format: string): string {
		return DateUtilities.convertDateFromCustomFormat(date, customFormat, format);
	}
}

@Pipe({
	name: 'dateUTCLocale'
})
export class DateUtcPipeLocale implements PipeTransform {
	transform(date: any, format: string): string {
		return DateUtilities.getDateFromUtcDate(date, format);
	}
}

@Pipe({
	name: 'dateCustom'
})
export class DateCustomFormat implements PipeTransform {
	transform(date: any, format: string): string {
		return DateUtilities.getDateCustomFormat(date, format);
	}
}

@Pipe({
	name: 'dateOffsetUTC'
})
export class DateOffsetUtcPipe implements PipeTransform {
	transform(date: any, formats: string | string[], timeZone?: boolean): string {
		if (Utilities.isVoid(formats)) {
			return DateUtilities.convertUtcDate(date);
		}
		if (typeof formats === 'string') {
			return DateUtilities.convertUtcDate(date, formats);
		}

		let result = '';
		for (let i = 0; i < formats.length; i++) {
			result += DateUtilities.convertUtcDate(date, formats[i]);
			if (i !== formats.length - 1) {
				result += ' ';
			}
		}

		return result;
	}
}
